import 'intersection-observer';
import Scrollama from 'scrollama';
export const bgBlur = (bgEl) => {
    if (bgEl === null) {
        return;
    }
    const scroller = Scrollama();
    scroller.setup({
        step: '#js-header',
        offset: 0.4
    })
        .onStepExit(evt => {
        if (evt.direction === 'down') {
            bgEl.classList.add('blur');
        }
    })
        .onStepEnter(evt => {
        if (evt.direction === 'up') {
            bgEl.classList.remove('blur');
        }
    });
    const scroller2 = Scrollama();
    scroller2.setup({
        step: '.sqex-header',
        offset: 0
    })
        .onStepExit(evt => {
        if (evt.direction === 'down') {
            bgEl.classList.add('fixed');
        }
    })
        .onStepEnter(evt => {
        if (evt.direction === 'up') {
            bgEl.classList.remove('fixed');
        }
    });
};
